import axios from "axios";
import { trackEvent } from "./analytics";

function cancelPropertyCreation () {
    axios.put('/update/session', {new_property_session: null}).then(function (resp) {
        if (resp.data.status) {
            window.location.href = '/'
        }
    })
}

function newPropertyCreation () {
    trackEvent({name: 'pm_myproperties_addprop', type: 'Action'})
    axios.put('/update/session', {
        new_property_session: {subscription: null}
    }).then(function (resp) {
        if (resp.data.status) {
            window.location.href = '/account/subscriptionUpdate'
        }
    })
}
// this makes the functions exported for use by blade template JS scripts and is used by webpack
export const propertiesModule = {
    cancelPropertyCreation,
    newPropertyCreation,
}